import { inject } from '@angular/core';
import { CountryApi } from '@app/api/country.api';
import { CountryDto } from '@app/models';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';

interface CountriesState {
  countries: CountryDto[];
  isLoading: boolean;
}

const initialState: CountriesState = {
  countries: [],
  isLoading: false,
};

export const CountriesStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),

  withMethods((store) => {
    const countryApi = inject(CountryApi);

    const loadCountries = rxMethod<void>(
      pipe(
        tap(() => patchState(store, { isLoading: true })),
        switchMap(() => countryApi.getCountries$()),
        tap((countries) => patchState(store, { countries, isLoading: false })),
      ),
    );

    const clearCountries = () => patchState(store, initialState);

    return {
      loadCountries,
      clearCountries,
    };
  }),
);
